import { axiosInstance } from '../../utils';
import { useMutation } from '@tanstack/react-query';

interface Payload {
  id: string;
  name: string;
}

export const updateVideoName = async (payload: Payload): Promise<any> => {
  const res = await axiosInstance.put(`/api/video-clipper/update`, payload);
  return res.data;
};

export function useUpdateVideoName() {
  return useMutation(updateVideoName, { onSuccess: (data) => data });
}
